import React from 'react';

const Icon = ({iconName, classNames = "h-fit "}) => {
    const MainView = () => (
        <img
        src={`/assets/${iconName}`}
        alt={`${iconName} icon`}
        className= {classNames}
    />
    )
    return MainView()
}
export default Icon